
<template>
    <div
         @mouseover="onMouseClick"
         @mouseout="onMouseOut"
         class="el-clickthrough">
        <vue-lottie :options="defaultOptions"
            class="center-animation"
            @animCreated="handleAnimation"

            @complete="complete"
            @loopComplete="loopComplete"
            @enterFrame="enterFrame"
            @segmentStart="segmentStart"
            @configReady="config_ready"
            @dataReady="data_ready"
            @loadedImages="loaded_images"
            @destroy="destroy"
            @DOMLoaded="DOMLoaded"
            />
    </div>
</template>
 
<script>
import VueLottie from '@/components/AnimLottie'
import * as animationData from '../assets/animations/face.json'

export default {
    components: {
        VueLottie
    },
    props: {
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 140
        },
        options: {
            type: Object
        }
    },
    data () {
        return {
            defaultOptions: {
                animationData: animationData,
                autoplay: false,
                loop: false
            },
            animLoaded: false,
            animations: {
                blink: [[547, 554]],
                poke: [[1, 16]],
                dazed: [[22, 110]],
                smirk: [[115, 192]],
                boredEyeRoll: [[216, 556]],
                sigh: [[432, 504]],
                returnNeutral: [[510, 556]],
                rightEyeDrift: [[555, 631]],
                eyesAttemptMouseFollow: [[632, 803]],
                bothEyesDriftInDifferentDirections: [[804, 892]],
                eyesDartAroundScreen: [[893, 966]],
                eyesBothGoWide: [[967, 1039]]
            }
        }
    },
    watch: {
        animLoaded () {
            let i = 0 // Starting value for filter loop
            let delay = 13600 // Longest animation
            let skip = ['blink', 'poke', 'dazed', 'sigh', 'returnNeutral'] // Filter out these keys from this.animations

            // Filter out keys we don't want in our loop
            const filtered = Object.keys(this.animations)
                .filter(key => !skip.includes(key))
                .reduce((obj, key) => {
                    obj[key] = this.animations[key];
                    return obj;
                }, {});
            
            // Instantiate timeout animation sequence
            for (const [key, value] of Object.entries(filtered)) {
                i++
                // console.log(key, value, i);
                setTimeout(() => {
                    this.anim.playSegments(value[0], true)
                }, delay * i);
            }

            // Instantiate blink loop after animation sequence has finished
            this.faceBlinkLoopTimeout = setTimeout(() => {
                this.startFaceBlinkLoop()
            }, delay * i + 1);
            
            // Retaining incase we need fine tunes controls...
            // setTimeout(() => {
            //     this.faceBoredEyeRoll()
            // }, delay * 1);
            // setTimeout(() => {
            //     this.rightEyeDrift()
            // }, delay * 2);
            // setTimeout(() => {
            //     this.eyesAttemptMouseFollow()
            // }, delay * 3);
            // setTimeout(() => {
            //     this.bothEyesDriftInDifferentDirections()
            // }, delay * 4);
            // setTimeout(() => {
            //     this.eyesDartAroundScreen()
            // }, delay * 5);
            // setTimeout(() => {
            //     this.eyesBothGoWide()
            // }, delay * 6);
        }
    },
    methods: {
        handleAnimation (anim) {
            this.anim = anim
            // console.log('ANIM', anim)
            this.animLoaded = true
        },
        onMouseClick (e) {
            this.clearFaceBlinkLoop()
            this.anim.playSegments(this.animations.poke[0], true)
            setTimeout(() => {
                this.anim.pause()
            }, 56);
        },
        onMouseOut (e) {
            this.anim.playSegments([8, 16], true)
        },
        clearFaceBlinkLoop () {
            this.faceBlinkLoopStarted = false
            clearTimeout(this.faceBlinkLoopTimeout)            
            clearTimeout(this.blinkTimeout)
        },
        startFaceBlinkLoop () {
            this.faceBlinkLoopStarted = true
            this.blinkTimeout = setTimeout(() => {
                this.anim.playSegments(this.animations.blink[0], true)
                this.startFaceBlinkLoop()
            }, 10000);
        },

        // Helper Functions
        stop () {
            this.anim.stop()
        },
        play () {
            this.anim.play()
        },
        pause () {
            this.anim.pause()
        },
        // Animation Event Listeners
        enterFrame (e) {
            // console.log('enterFrame', this.anim)
            // if (Math.round(this.anim.currentFrame) === 78) {
            //     this.anim.goToAndPlay(13, true)
            // }
        },
        complete (e) {
            // console.log('complete', e)
        },
        loopComplete (e) {
            // console.log('loopComplete', e)
            // this.stop()
        },
        segmentStart (e) {
            // console.log('segmentStart', e)
        },
        config_ready (e) {
            // console.log('config_ready', e)
        },
        data_ready (e) {
            // console.log('data_ready', e)
        },
        loaded_images (e) {
            // console.log('loaded_images', e)
        },
        DOMLoaded (e) {
            // console.log('DOMLoaded', e)
        },
        destroy (e) {
            // console.log('destroy', e)
        }
    }
}
</script>

<style lang="scss" scoped>
    .el-clickthrough {
        display: block;
        min-width: 80px;
        min-height: calc(#{$nav-min-height} + 2rem);
        overflow: hidden;
        width: 90px;
        height: 140px;

        @include mq($from: desktop) {
            width: 7vw !important;
            height: calc(#{$nav-height} + 2vw) !important;
        }
        * {
            pointer-events: none;
        }
    }
    .center-animation {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        min-width: 200px;
        min-height: calc(#{$nav-min-height} + 2rem);
        width: 200px !important;
        height: 140px !important;

        @include mq($from: desktop) {        
            width: 12vw !important;
            height: calc(#{$nav-height} + 2vw) !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AnimLogo.vue